import React from 'react';
import { Link } from 'react-router-dom';
import styles from './LegalPage.module.css';

function TermsPage() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.container}>
        <h1>Terms of Service</h1>
        <p className={styles.lastUpdated}>Last updated: 1/17/26</p>

        <section className={styles.section}>
          <p>
            By downloading or using any Ragged Spade application, the user agrees to these Terms of Service.
            If these Terms are not accepted, the App should not be used.
          </p>
        </section>

        <section className={styles.section}>
          <h2>1. License and Use</h2>
          <p>
            Ragged Spade LLC grants a limited, non-exclusive, non-transferable license to use the App
            for personal, non-commercial purposes.
          </p>
          <p>The user agrees not to:</p>
          <ul>
            <li>Reverse engineer, modify, or redistribute the App</li>
            <li>Use the App for unauthorized commercial purposes</li>
            <li>Interfere with the App's operation or security</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>2. In-App Purchases</h2>
          <p>Some Apps offer optional in-app purchases.</p>
          <p>All purchases:</p>
          <ul>
            <li>Are final and non-refundable except where required by law</li>
            <li>Are governed by Apple App Store policies</li>
          </ul>
          <p>Availability of cosmetic or digital items is not guaranteed indefinitely.</p>
        </section>

        <section className={styles.section}>
          <h2>3. No Warranty</h2>
          <p>The Apps are provided "as is" and "as available."</p>
          <p>No warranties are made regarding:</p>
          <ul>
            <li>Accuracy</li>
            <li>Reliability</li>
            <li>Availability</li>
            <li>Fitness for a particular purpose</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>4. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Ragged Spade LLC is not liable for damages
            arising from use of the Apps, including but not limited to:
          </p>
          <ul>
            <li>Loss of data</li>
            <li>Device malfunction</li>
            <li>Lost progress</li>
            <li>Financial loss</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>5. Hold Harmless and Indemnification</h2>
          <p>
            The user agrees to indemnify and hold harmless Ragged Spade LLC, its owners, and
            affiliates from any claims, damages, or liabilities arising from:
          </p>
          <ul>
            <li>Use of the App</li>
            <li>Violation of these Terms</li>
            <li>Misuse of the App</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>6. Termination</h2>
          <p>
            Access to the App may be suspended or terminated at any time without notice if
            these Terms are violated.
          </p>
        </section>

        <section className={styles.section}>
          <h2>7. Governing Law</h2>
          <p>
            These Terms are governed by the laws of the United States and the state in which
            Ragged Spade LLC is registered, without regard to conflict-of-law rules.
          </p>
        </section>

        <section className={styles.section}>
          <h2>8. Changes to Terms</h2>
          <p>
            These Terms may be updated at any time. Continued use of the App constitutes
            acceptance of the updated Terms.
          </p>
        </section>

        <div className={styles.backLink}>
          <Link to="/">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
